module.exports = __webpack_public_path__ + "static/media/ic_sp_horizontal_active.43a5f652.svg";